import React from 'react';
import './Footer.css';

import { images } from '../../constants';

import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedin, FaEnvelope, FaAngleDoubleRight } from 'react-icons/fa';
import { AiTwotonePhone } from 'react-icons/ai';
import { BsMapFill } from 'react-icons/bs';



const Footer = () => {

  return (
    <footer className='footer'>

      <div className='box-container'>

        <div className='footer-item'>
          <a href='#' className='logo'>
            <img src={images.logo} alt='header-logo' />
            <h2>S.H.C.C. INGENIERÍA</h2>
          </a>
        </div>
      </div>


    </footer>
  )
}

export default Footer;